
import './Logout.css';

function Logout() {
    return (
        <div className="logout">

        </div>
    )
}

export default Logout;